var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property, listing_index, is_single_unit } = options; 
__p+='\n<div class="listing-'+
((__t=( listing_index ))==null?'':__t)+
' listing-card-compact browse-module-card js-tracking ';
 if (is_single_unit == true) { 
__p+='col-sm-6';
 } 
__p+='" data-url="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'" data-status="'+
((__t=( property.prop_status ))==null?'':__t)+
'" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'">\n  <a href="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" aria-label="'+
((__t=( property.address_display ))==null?'':__t)+
'" class="bm-link-overlay" data-omtag="ldp:oth-bldng-units:for-sale:units:card" itemprop="url" target="_blank"></a>\n  ';

    let photo_class = '';
    if (!property.photo_url) { photo_class = "photo-not-available-480w"};
  
__p+='\n  <div class="aspect-content compact-card-image-wrapper '+
((__t=( photo_class ))==null?'':__t)+
'">\n    ';
 if (property.photo_url){ 
__p+='\n      ';
 if (listing_index <= 5){
__p+='\n        <img src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="compact-card-image" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n      ';
 } else { 
__p+='\n        <img src="" data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="owl-lazy compact-card-image" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n      ';
 } 
__p+='\n    ';
 } else { 
__p+='\n      <div class="image-placeholder"></div>\n    ';
 } 
__p+='\n    <div class="compact-card-price">\n      '+
((__t=( property.price_display ))==null?'':__t)+
'\n    </div>\n    ';
 if(property.search_flags && (property.search_flags.is_new_listing || property.search_flags.is_pending || property.search_flags.is_contingent)) { 
__p+='\n    <div class="compact-card-label">\n       ';
 if(property.search_flags.is_pending){ 
__p+='\n         <span class="label label-red display-inline-block" data-label="property-label-pending">Pending</span>\n       ';
 } else if(property.search_flags.is_contingent){ 
__p+='\n         <span class="label label-red display-inline-block" data-label="property-label-contingent">Contingent</span>\n       ';
 } else if(property.search_flags.is_new_listing){ 
__p+='\n         <span class="label label-green label-outline-none display-inline-block" data-label="property-label-new">New</span>\n       ';
 } 
__p+='\n     </div>\n     ';
 } 
__p+='\n  </div>\n  <div class="compact-card-content">\n    <div class="compact-card-address ellipsis">\n      <span itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">\n        ';
 if (property.address_display){ 
__p+='\n          <span itemprop="streetAddress">'+
((__t=( property.address_display ))==null?'':__t)+
'</span>\n\n        ';
 } else { 
__p+='\n          <span itemprop="streetAddress">Address Not Available</span>\n        ';
 } 
__p+='\n      </span>\n      <span itemprop="geo" itemscope itemtype="http://schema.org/GeoCoordinates">\n        <meta itemprop="latitude" content="'+
((__t=( property.lat ))==null?'':__t)+
'"></meta>\n        <meta itemprop="longitude" content="'+
((__t=( property.lon ))==null?'':__t)+
'"></meta>\n      </span>\n    </div>\n    <div class="compact-card-meta">\n      ';
 if (((property.beds_display) || (property.baths_display)) || (property.sqft_display)){ 
__p+='\n        <ul class="list-horizontal list-style-disc">\n          ';
 if (property.beds_display){ 
__p+='\n            <li data-label="compact-meta-beds">'+
((__t=( property.beds_display ))==null?'':__t)+
'</li>\n          ';
 } 
__p+='\n          ';
 if (property.baths_display){ 
__p+='\n            <li data-label="compact-meta-baths">'+
((__t=( property.baths_display ))==null?'':__t)+
'</li>\n          ';
 } 
__p+='\n          ';
 if (property.sqft_display){ 
__p+='\n            <li class="compact-meta-sqft " data-label="property-meta-sqft">'+
((__t=( property.sqft_display ))==null?'':__t)+
'</li>\n          ';
 } 
__p+='\n        </ul>\n      ';
 } else {
__p+='\n        Nearby Property\n      ';
 } 
__p+='\n    </div>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/building-unit/browse-module-card.jst.ejs